import PropTypes from 'prop-types';
import * as yup from 'yup';
import { Formik } from 'formik';
import { Button, DropdownSelect, Error } from '@figure/frontlib-gui';
import { FormErrorHandler } from 'shared/components';
import { T_SHIRT_SIZE } from 'shared/constants/t-shirt';

const ShirtForm = ({ handleSubmit, serverError }) => (
  <Formik
    initialValues={{
      tShirtSize: '',
    }}
    validationSchema={() =>
      yup.lazy(() =>
        yup.object().shape({
          tShirtSize: yup.string().required('Required'),
        })
      )
    }
    onSubmit={handleSubmit}
  >
    {({ values, errors, touched, setFieldValue, handleSubmit }) => (
      <>
        <FormErrorHandler errors={errors} touched={touched} serverError={serverError} />
        <form onSubmit={handleSubmit}>
          <DropdownSelect
            id="t-shirt-size"
            label="Tell us your t-shirt size (shirts are unisex)"
            name="t-shirt-size"
            value={values.tShirtSize}
            errorText={touched.tShirtSize && errors.tShirtSize}
            onChange={(e) => setFieldValue('tShirtSize', e.target.value)}
          >
            <option value="" />
            {T_SHIRT_SIZE.map((entry) => (
              <option key={entry.value} value={entry.value}>
                {entry.label}
              </option>
            ))}
          </DropdownSelect>

          <Error display="block">{serverError}</Error>

          <Button type="submit" onClick={handleSubmit} primary large center>
            Confirm
          </Button>
        </form>
      </>
    )}
  </Formik>
);

ShirtForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  serverError: PropTypes.string.isRequired,
};

export default ShirtForm;
